import { PermitListItemFromJSON, PermitListItemToJSON, } from './PermitListItem';
/**
 * Check if a given object implements the ListDefaultPermitsResponse interface.
 */
export function instanceOfListDefaultPermitsResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "permits" in value;
    return isInstance;
}
export function ListDefaultPermitsResponseFromJSON(json) {
    return ListDefaultPermitsResponseFromJSONTyped(json, false);
}
export function ListDefaultPermitsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'total': json['total'],
        'permits': (json['permits'].map(PermitListItemFromJSON)),
    };
}
export function ListDefaultPermitsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total': value.total,
        'permits': (value.permits.map(PermitListItemToJSON)),
    };
}
